import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Toggle from './Toggle'
import { classNames, Icon, iconProps } from '@zambezi/sdk/common'

/**
 * Create a React Star Toggle component
 *
 * @param {import('./interfaces').StarToggleProps} props
 * @returns {JSX.Element}
 */
function StarToggle ({ className, iconProps, ...props }) {
  const renderFn = useCallback(
    () => <Icon name='core-toggle-star' iconProps={iconProps} />,
    [iconProps]
  )
  return (
    <Toggle
      {...props}
      className={classNames('zb-toggle-star', className)}
      renderFn={renderFn}
    />
  )
}

StarToggle.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  pressed: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultPressed: PropTypes.bool,
  tabIndex: PropTypes.string,
  onChange: PropTypes.func,
  iconProps: iconProps
}

StarToggle.defaultProps = {
  defaultPressed: false,
  pressed: undefined,
  disabled: false,
  tabIndex: '0',
  onChange: () => undefined
}

export default StarToggle
